// extracted by mini-css-extract-plugin
export default {"skill_wrapper":"Skills_skill_wrapper__VyUm0","paragraph":"Skills_paragraph__3Fbdo"};